import React from 'react';
import { Col, Row, Card } from 'react-bootstrap';
import { VirtualTableScrollbar } from '../../common/components';
import * as ModelsWorkflowInbox from '../../models/workflow/WorkflowInbox';
import { useVirtualTableScrollbar } from '../../common/hooks';
import { TbDatabaseEdit, TbDatabaseExport } from 'react-icons/tb';
import { getStyleObjectFromString } from 'helpers/reactInlineStyleToObject';
import { ReportTableCustomTableData } from './ReportTableCustomTableData';
import { ReportTableCustomTableHeader } from './ReportTableCustomTableHeader';

var imgItem = require('../../assets/image/report-item.png');

type Align = 'left' | 'center' | 'right';

export type ReportTableProps = {
    listItem: ModelsWorkflowInbox.DataItem;
    disabledTips?: boolean;
};

export const ReportTable = (props: ReportTableProps) => {
    const { disabledTips, listItem } = props;

    console.log(listItem);

    const {
        tableContainerRef,
        virtualTableContainerRef,
        virtualTableRef,
        tableRefCallback
    } = useVirtualTableScrollbar();

    return (
        <Row className="mt-3">
            <Col>
                <Card style={{
                    borderRadius: '15px',
                    background: 'none',
                    border: 'none',
                }}
                >
                    <Card.Header
                        style={{
                            backgroundColor: '#FAEDC4',
                            border: 'none',
                            borderTopLeftRadius: '15px',
                            borderTopRightRadius: '15px'
                        }}
                    >
                        <Row>
                            <img
                                src={imgItem}
                                style={{
                                    marginLeft: '16px',
                                    marginRight: '16px',
                                    marginTop: '4px',
                                    marginBottom: '4px',
                                    width: '20px',
                                    height: '20px'
                                }}
                                alt="file"
                            />
                            <p style={{
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <b>Item Details</b>
                            </p>
                        </Row>
                    </Card.Header>
                    <Card.Body
                        style={{
                            border: '1px solid #D9D9D9',
                            borderBottomLeftRadius: '15px',
                            borderBottomRightRadius: '15px',
                            borderTop: 'none'
                        }}
                    >

                        {!disabledTips && (
                            <p className="text-primary-900 text-right text-sm">
                                Tips: สามารถกดปุ่ม{' '}
                                <span className="rounded-sm border bg-stone-100 px-0.5 text-neutral-950">
                                    Shift
                                </span>{' '}
                                ค้างและหมุนลูกกลิ้งเมาส์เพื่อเลื่อนตารางในแนวนอนได้
                            </p>
                        )}
                        {/* <VirtualTableScrollbar
                            virtualTableContainerRef={virtualTableContainerRef}
                            virtualTableRef={virtualTableRef}
                        /> */}
                        <div
                            ref={tableContainerRef}
                            className="overflow-x-scroll"
                        >
                            <table
                                ref={tableRefCallback}
                                className="table-bordered table w-max"
                                style={{
                                    background: 'none',
                                    border: '1px solid #D9D9D9',
                                }}
                            >
                                <thead>
                                    <tr
                                        //className="table-active"
                                        style={{
                                            backgroundColor: '#FAEDC4',
                                            //border: 'none',
                                            border: '1px solid #D9D9D9',
                                        }}
                                    >
                                        {listItem.tableheader.map((header, idx) => (
                                            <ReportTableCustomTableHeader
                                                key={idx}
                                                style={{
                                                    width: header.width
                                                        ? `${header.width}px`
                                                        : 'auto',
                                                    textAlign: header.align as Align,
                                                }}
                                                styleString={header.style}
                                                // colSpan={parseInt(header.attribute?.[0].value ?? 1)}
                                                attribute={header.attribute}
                                            >
                                                {header.label}
                                            </ReportTableCustomTableHeader>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {listItem.tabledata.map((item, idx) => (
                                        <tr key={idx}>
                                            {item.row && item.row.map((cell, cellIdx) => (
                                                <td
                                                    key={cellIdx}
                                                    style={{
                                                        textAlign: listItem.tableheader[
                                                            cellIdx
                                                        ]?.align as Align
                                                    }}
                                                >
                                                    {cell}
                                                </td>
                                            ))}
                                            {item.rowcustom && item.rowcustom.map((cell, cellIdx) => (
                                                <ReportTableCustomTableData
                                                    key={cellIdx}
                                                    styleString={cell.style}
                                                    style={{
                                                        textAlign: cell.align as Align,
                                                        width: cell.width
                                                    }}
                                                    attribute={cell.attribute}
                                                >
                                                    {cell.label}
                                                </ReportTableCustomTableData>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
};
